import { render, staticRenderFns } from "./MadeByComponent.vue?vue&type=template&id=4b226422&"
import script from "./MadeByComponent.vue?vue&type=script&lang=js&"
export * from "./MadeByComponent.vue?vue&type=script&lang=js&"
import style0 from "./MadeByComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports